import React from 'react';
import { Breadcrumb, DOMHelper, Panel, Table, useToaster } from 'rsuite';
import DataTable from './DataTable';
import { useTranslation } from 'react-i18next';

const { Column, HeaderCell, Cell } = Table;
const { getHeight } = DOMHelper;

const ProfilesAccess = () => {
  const toaster = useToaster();
  const { t } = useTranslation();
  return (

    <Panel
      header={
        <>
          <h3 className="title">{t('Access profiles')}</h3>{' '}
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Access profiles')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <DataTable />
    </Panel>
  );
};

export default ProfilesAccess;
